import { gql } from "@apollo/client";

export default gql`
  mutation updateCustomerPerson($data: UpdateCustomerPersonInput!){
    updateCustomerPerson(data: $data){
        success
        data{
            _id
            customer
            type
            status
            firstName
            lastName
            profilePhoto
            isEmailVerified
            email
            phone
            language
            timeZone
            devices{
                type
                status
                lastLoginTime
                statusAwayTime
            }
            dateFormat
            joinedConvLimit
            joinedConvCount
            signedTeams
            notificationSettings{
                conversationSound
                messageSound
                notificationSoundVolume
                notificationCardEnabled
                mobilePushNotifications
                newUnassignedConversation{
                    web
                    mobile
                    email
                    sound
                    loopScope
                }
                newConversationAssignedToMe{
                    web
                    mobile
                    email
                    sound
                    loopScope
                }
                newMessagesInConversationsAssignedToMe{
                    web
                    mobile
                    email
                    sound
                    loopScope
                }
                newMessagesInUnassignedConversations{
                    web
                    mobile
                    email
                    sound
                    loopScope
                }
                taskReminder{
                    web
                    mobile
                    email
                    sound
                    loopScope
                }
                newTableRecordAssignedToMe{
                    web
                    mobile
                    email
                    sound
                    loopScope
                }
                newCommentInAssignedTableRecord{
                    web
                    mobile
                    email
                    sound
                    loopScope
                }
                newPrivateChatMessage{
                    web
                    mobile
                    email
                    sound
                    loopScope
                }
                newTeamChatMessage{
                    web
                    mobile
                    email
                    sound
                    loopScope
                }
                importRecordsToTable{
                    web
                    mobile
                    email
                    sound
                    loopScope
                }
                exportTableRecords{
                    web
                    mobile
                    email
                    sound
                    loopScope
                }
                importContacts{
                    web
                    mobile
                    email
                    sound
                    loopScope
                }
                exportContacts{
                    web
                    mobile
                    email
                    sound
                    loopScope
                }
                noteMention{
                    web
                    mobile
                    email
                    sound
                    loopScope
                }
                taskCommentMention{
                    web
                    mobile
                    email
                    sound
                    loopScope
                }
                trackingDomainVerified{
                    web
                    mobile
                    email
                    sound
                    loopScope
                }
                exportReport{
                    web
                    mobile
                    email
                    sound
                    loopScope
                }
                qpienAnnouncements{
                    web
                    mobile
                    email
                    whatsapp
                }
            }
            isAcceptingCalls
            canAccessPhoneCalls
            isInCall
            is2FAEnabled
            hasPassword
            archivedAt
            hasAiAssistant
            productTour{
                mainCompletedAt
                mainSkippedAt
                boardsCompletedAt
                welcomeVideoWatchedAt
                modules
            }
        }
        code
        message
    }
}
`
